import Caption from 'LuxKit/Typography/Caption'
import Group from 'components/utils/Group'
import React from 'react'
import { useIntl } from 'react-intl'

type Props = {
  offer: App.VillaOffer | App.VillaOfferSummary
  locationHeading?: string
  locationSubheading?: string
}

function VillaLocationCaption(props: Props) {
  const { offer } = props
  const intl = useIntl()

  return (
    <Group direction="horizontal" gap={4}>
      <Caption colour="neutral-two" variant="large">
        {[offer.locationHeading, offer.locationSubheading].filter((t) => t).join(', ')}
      </Caption>
      <Caption variant="large" colour="neutral-three">
        {'· ' + intl.formatMessage({
          id: 'pdN6LJKohc',
          defaultMessage: 'Villa',
          description: 'Property type label for villa offer cards',
        })}
      </Caption>
    </Group>
  )
}

export default VillaLocationCaption
